import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Checkbox } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import React, { useCallback, useState } from "react";
import { CSVLink } from "react-csv";
import { debounce } from "../../../../../utils";
import "../../../../Admin/Reports/Reports Detailed/ReportsDetailed.css";
import { BreadcrumbAdmin } from "../../../../UI/BreadcrumbAdmin";
import { Search } from "../../../../UI/Search/Search";
import { useOutsideClick } from "../../../../../hooks/useOutsideClick";
import { OrgBookSummaryTable } from "./OrgBookSummaryTable";

const list = [
  { name: "bookOrder", label: "Book Order" },
  { name: "bookName", label: "Book Name" },
  { name: "totalOrganisationUsers", label: "Total Organisation User" },
  { name: "eligibleUsers", label: "Eligible User" },
  { name: "completed", label: "Completed" },
  { name: "ongoing", label: "Ongoing (Current Book)" },
  { name: "locked", label: "Locked (Not Yet Reached)" },
  { name: "completionPercent", label: "Completion %" },
];

const formatPercent = (value) =>
  value == null ? "0%" : `${Number(value).toFixed(1)}%`;

export const OrgBookSummary = () => {
  const [select, setSelect] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const ref = React.useRef(null);
  const [csvData, setCsvData] = useState([]);
  const [check, setCheck] = useState({
    bookOrder: true,
    bookName: true,
    totalOrganisationUsers: true,
    eligibleUsers: true,
    completed: true,
    ongoing: true,
    locked: true,
    completionPercent: true,
  });

  const closePopup = () => {
    setSelect(false);
  };

  useOutsideClick(ref, closePopup);

  const base = [
    {
      _id: 1,
      link: "/super-admin/reports",
      label: "Reports",
    },
  ];

  const setDebouncedSearchQuery = useCallback(
    debounce((value) => {
      setSearchQuery(value);
    }, 500),
    []
  );

  const handleChange = (e) => {
    setCheck({ ...check, [e.target.name]: e.target.checked });
  };

  return (
    <div className="container">
      <BreadcrumbAdmin base={base} page="Org Book Summary" />
      <p className="reportsDetailed__subtitle">
        Books are listed in the fixed sequence employees must follow. Each
        employee can only be on one active book at a time. Counts cover all
        companies for active, non-deleted organisation users.
      </p>
      <div className="reportsDetailed__head">
        <Search
          mini
          setSearchVal={(val) => setDebouncedSearchQuery(val)}
          placehold="Search by book name..."
        />
        <div className="reportsDetailed__headright">
          <div ref={ref} className="reports__selectLayout">
            <Button
              variant="outlined"
              endIcon={
                <ArrowForwardIosIcon
                  sx={{
                    transform: select ? "rotate(-90deg)" : "rotate(90deg)",
                    color: "grey",
                    fontSize: "16px !important",
                  }}
                />
              }
              sx={{
                color: "var(--grey400)",
                borderColor: "var(--grey300)",
                width: "150px",
                fontWeight: "400 !important",
              }}
              onClick={() => setSelect(!select)}
            >
              Manage Field
            </Button>
            <div
              className={select ? "reports__selectActive" : "reports__select"}
            >
              <div className="reports__selectcontent">
                {list.map((item, index) => (
                  <FormControlLabel
                    key={index}
                    control={
                      <Checkbox
                        checked={Boolean(check[item.name])}
                        name={item.name}
                        onChange={handleChange}
                        sx={{ "& .MuiSvgIcon-root": { fontSize: "20px" } }}
                      />
                    }
                    label={
                      <span style={{ fontSize: "15px" }}>{item.label}</span>
                    }
                  />
                ))}
              </div>
            </div>
          </div>
          <CSVLink filename="Org-book-summary" data={csvData}>
            <Button
              variant="contained"
              endIcon={<FileUploadOutlinedIcon sx={{ color: "white" }} />}
            >
              Export
            </Button>
          </CSVLink>
        </div>
      </div>

      <div className="reports__table">
        <OrgBookSummaryTable
          check={check}
          searchQuery={searchQuery}
          getTableData={(data) => {
            const cleanedCSVData = data?.data?.map((obj) => ({
              "Book Order": obj.bookOrder,
              "Book Name": obj.bookName,
              "Total Organisation User": obj.totalOrganisationUsers,
              "Eligible User": obj.eligibleUsers,
              Completed: obj.completed,
              "Ongoing (Current Book)": obj.ongoing,
              "Locked (Not Yet Reached)": obj.locked,
              "Completion %": formatPercent(obj.completionPercent),
            }));
            setCsvData(cleanedCSVData);
          }}
        />
      </div>
    </div>
  );
};
